export default "__VITE_ASSET__DYV24_an__"